import { Component, Input, ChangeDetectionStrategy, inject, DestroyRef, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Ticket } from '@shared/entities/ticket';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-icam-ticket',
  templateUrl: './icam-ticket.component.html',
  styleUrl: './icam-ticket.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IcamTicketComponent {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private _themeService = inject(ThemeService);
  public translateService = inject(TranslateService);

  isSolutionOpen = false;
  isLight = true;
  @Input() ticket!: Ticket;

  constructor() {
    this._themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => {
          this.isLight = x;
          this._cdr.markForCheck();
        })
      )
      .subscribe();
  }
}
